<template>
    <div>
        <!-- Marks -->
        <noncustom-prop v-if="object.categ_10" :object='object' :property='{label: object.categ_10.label, column: "categ_10"}'>
        </noncustom-prop>

        <!-- Place -->
        <div class='row' v-if='places'>
            <div class='col-md-3'><strong>{{object.custom_place.label}}</strong></div>
            <div class='col-md-9'>
                <span v-for='entry, index in object.custom_place.value'>
                    <a :href="generateLink({'searchable-places-keyword': entry})" v-html='entry'></a>
                </span>
            </div>
        </div>

        <!-- Notes -->
        <noncustom-prop v-if="object.intr_mem" :object='object' :property='{label: object.intr_mem.label, column: "intr_mem"}'>
        </noncustom-prop>

        <!-- Dimension -->
        <noncustom-prop v-if="object.categ_15" :object='object' :property='{label: object.categ_15.label, column: "categ_15"}'>
        </noncustom-prop>

    </div>
</template>

<script>
    import manageProperties from './../../../mixins/manageProperties.js'
    import NoncustomVue from '../parts/noncustom.vue'

    export default {
        props: ['object'],
        mixins: [manageProperties],
        components: {
            'noncustom-prop': NoncustomVue,
        },
        computed: {
            places: function () {
                // return this.concatProps(this.object, 'custom_place', ", ")
                const custom_place = this.localObject?.custom_place;
                if (!custom_place) return '';
                return this.concatProps({ custom_place }, 'custom_place', ', ')
            }
        }
    }
</script>
